export const DateDiff = {
    inDays(d1, d2) {
        const t2 = d2.getTime();
        const t1 = d1.getTime();
        const dayDifference = (t2 - t1) / (24 * 3600 * 1000);
        return dayDifference;
    },

    inWeeks(d1, d2) {
        const t2 = d2.getTime();
        const t1 = d1.getTime();

        return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7));
    },

    inMonths(d1, d2) {
        const d1Y = d1.getFullYear();
        const d2Y = d2.getFullYear();
        const d1M = d1.getMonth();
        const d2M = d2.getMonth();

        return (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
    },

    inYears(d1, d2) {
        return d2.getFullYear() - d1.getFullYear();
    },
};

export function forceToMonFri(date) {
    if (typeof date === 'string') date = new Date(date);
    if (date.getDay() > 1 && date.getDay() < 5) {
        const diff = Math.abs(1 - date.getDay());
        date = new Date(date.getTime() - (diff * 1000 * 60 * 60 * 24));
    } else if (date.getDay() > 5) {
        const diff = Math.abs(5 - date.getDay());
        date = new Date(date.getTime() - (diff * 1000 * 60 * 60 * 24));
    } else if (date.getDay() === 0) {
        date = new Date(date.getTime() + (1000 * 60 * 60 * 24));
    }

    return date;
}

export default DateDiff;
